<template>
  <div class="prizes-2021-promo-product-list">
    <div
      class="prizes-2021-promo-product-list__item"
      v-for="item in list"
      :key="item.id"
    >
      <Prizes2021PromoProduct :product="item" />
    </div>
  </div>
</template>

<script>
import Prizes2021PromoProduct from "./Prizes2021PromoProduct";

export default {
  name: "Prizes2021PromoProductList",
  components: {
    Prizes2021PromoProduct
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-promo-product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -15px;

  max-width: 600px;

  &__item {
    padding: 15px;
    width: 25%;
    display: flex;
    justify-content: center;
  }

  @include breakpoint("md-and-down") {
    max-width: calc(100% + 30px);
    justify-content: center;
  }

  @include breakpoint("sm-and-down") {
    margin: -10px;
    max-width: calc(100% + 20px);
  }

  @include breakpoint("xs-only") {
    &__item {
      padding: 10px;
      width: 50%;
    }
  }
}
</style>
